module.exports = __webpack_public_path__ + "img/dream1.463fbd40.jpg";